<script>
  import { onMount } from "svelte";
  import Form from "./Form.svelte";
  import { focusNext } from "./Form.svelte";

  import { HStack } from "../component/layout";
  import { Padding } from "../component/modifier";
  import { Email, validateEmail, Password, Digit, Text, Checkbox } from "./widget";
  import { navigate } from "../router";
  import { check, join, isJoined } from "../wedding.js";
  import { login, create, verify, lostPassword, uniqueNickname, load, userLogin } from "../user.js";

  export let step = 1;
  export let wedding = null;
  export let code = null;
  export let isLogin = false;
  export let bapteme = false;

  let steps = [];

  let showDone = false;
  let password = null;
  let recoverPassword = false;
  let validatePassword = false;

  function goToLostPassword() {
    reset();
    password = null;
    recoverPassword = true;
  }

  function updateSteps(isLogin) {
    if (isLogin) {
      steps = [
        {
          id: 1,
          name: "Code Invitation",
          done: false,
          back: false,
          cancel: true,
          submit: "continue",
          next: 2,
          prev: null,
        },
        {
          id: 2,
          name: "Connexion",
          done: false,
          back: code == null,
          cancel: true,
          submit: "validate",
          next: 4,
          prev: 1,
        },
        {
          id: 4,
          name: "Félicitations\n  ",
          done: false,
          back: false,
          cancel: false,
          next: null,
          prev: 2,
        },
      ];
    } else {
      steps = [
        {
          id: 1,
          name: "Code Invitation",
          done: false,
          back: false,
          cancel: true,
          submit: "continue",
          next: 2,
          prev: null,
        },
        {
          id: 2,
          name: "Création Compte",
          done: false,
          back: code == null,
          cancel: true,
          submit: "continue",
          next: 3,
          prev: 1,
        },
        {
          id: 3,
          name: "Validation Compte",
          done: false,
          back: true,
          cancel: false,
          submit: "validate",
          next: 4,
          prev: 2,
        },
        {
          id: 4,
          name: "Félicitations\n  ",
          done: false,
          back: false,
          cancel: false,
          next: null,
          prev: 3,
        },
      ];
    }
  }

  $: updateSteps(isLogin);

  let c1 = null;
  let c2 = null;
  let c3 = null;
  let c4 = null;
  let c5 = null;
  let c6 = null;
  let codeError = false;

  let form;
  let current = "";

  let codeUser;
  let nickname = null;

  $: email = isLogin ? $userLogin : null;

  let accept = null;
  let rsvp = true;

  let showInfo = false;
  let infoMessage = null;
  let showError = false;

  function reset() {
    showInfo = false;
    infoMessage = null;
    showError = false;
  }

  async function resendCode() {
    reset();
    await verify("send");
    infoMessage = "code envoyé";
    showInfo = true;
    c1 = null;
    c2 = null;
    c3 = null;
    c4 = null;
    c5 = null;
    c6 = null;
  }

  function translateError(e) {
    console.log(e.message);
    if (e.message === "401 - 26 Invalid code.") {
      return "Code incorrect.";
    }
    return e;
  }

  function checkCode() {
    if (form.checkValidity()) {
      form.requestSubmit();
    }
  }

  const submit = async () => {
    if (step == 1) {
      code = "" + c1 + c2 + c3 + c4 + c5 + c6;
      let result = await check(code);
      wedding = result.data;
      nickname = null;
      password = null;
    } else if (step == 2) {
      if (isLogin) {
        if (recoverPassword) {
          await lostPassword(email, "send");
          recoverPassword = false;
          validatePassword = true;
          return false;
        } else if (validatePassword) {
          code = "" + c1 + c2 + c3 + c4 + c5 + c6;
          await lostPassword(email, "verify", code, password);
          recoverPassword = false;
          validatePassword = false;
          showDone = true;
          return false;
        } else if (showDone) {
          showDone = false;
          return false;
        } else {
          let u = await login(email, password);
          console.log(u);
          if (u.data.verified == "0") {
            isLogin = false;
          } else {
            let result = await isJoined(wedding.guid);
            if (result.count == 0) {
              await join(wedding.guid, wedding.code, code);
            } else {
              // go to wedding
              //loadWedding();
              navigate(`#/wedding/${wedding.guid}/A`);
            }
            return true;
          }
        }
      } else {
        await create(email, password, nickname, code);
        await login(email, password);
        await verify("send");
        await join(wedding.guid, wedding.code, code);
      }

      c1 = null;
      c2 = null;
      c3 = null;
      c4 = null;
      c5 = null;
      c6 = null;
    } else if (step == 3) {
      codeUser = "" + c1 + c2 + c3 + c4 + c5 + c6;
      try {
        await verify("verify", codeUser);
      } catch (e) {
        codeError = true;
        throw e;
      }

      await load();
    } else if (step == 4) {
      //loadWedding();
      if (rsvp) {
          navigate(`#/wedding/${wedding.guid}/R?rsvp` + (bapteme ? '&b=1' : ''));
      } else {
        navigate(`#/wedding/${wedding.guid}/A` + (bapteme ? '&b=1' : ''));
      }
    }
  };

  function validate(event) {
    //console.log("validating", event.target.name);
    reset();
    switch (event.target.name) {
      case "email":
        validateEmail(event.target);
        break;
      case "nickname":
        validateNickname(event.target);
        break;
      case "c1":
      case "c2":
      case "c3":
      case "c4":
      case "c5":
      case "c6":
        codeError = false;
        if (
          event.target.value === "" ||
          event.target.value === null ||
          event.target.value === undefined
        ) {
          event.target.setCustomValidity("Un chiffre est requis.");
        } else {
          event.target.setCustomValidity("");
          if (event.target.name != "c6") {
            focusNext(form);
          }
          checkCode();
        }
        break;
      default:
        break;
    }
  }

  $: console.log("codeError", codeError);

  function validateNickname(textbox) {
    if (textbox.value === "" || textbox.value === null || textbox.value === undefined) {
      textbox.setCustomValidity("Un pseudo est requis.");
    } else {
      uniqueNickname(textbox.value)
        .then(() => textbox.setCustomValidity(""))
        .catch(() => textbox.setCustomValidity("Ce pseudo est déjà utilisé."));
    }
    return true;
  }

  onMount(() => {
    console.log("on mount JoinWithSignUp");
  });
</script>

<Form
  bind:form
  bind:step
  bind:steps
  {submit}
  {validate}
  {showInfo}
  bind:showError
  {infoMessage}
  {translateError}
  on:close
  padding={false}>
  <article>
    {#if step == 1}
      <p>Entrez votre code d'invitation pour continuer.</p>
      <Padding>
        <HStack justify="space-evenly" alignment="normal">
          <Digit id={"c1"} focused bind:value={c1} bind:current error={codeError} />
          <Digit id={"c2"} bind:value={c2} bind:current error={codeError} />
          <Digit id={"c3"} bind:value={c3} bind:current error={codeError} />
          <Digit id={"c4"} bind:value={c4} bind:current error={codeError} />
          <Digit id={"c5"} bind:value={c5} bind:current error={codeError} />
          <Digit id={"c6"} bind:value={c6} bind:current error={codeError} />
        </HStack>
        <p style="text-align: justify;font-size: small;">
          Si vous avez reçu un faire-part par e-mail, ce code n'est pas nécessaire. Il vous suffit
          d'utiliser le lien ou le QR code qui vous a été envoyé.
        </p>
        <p style="text-align: justify;font-size: small;">
          Si vous n'avez pas reçu de faire-part, veuillez contacter les mariés.
        </p>
      </Padding>
    {:else if step == 2}
      <h1>
        {#if bapteme}
        Bienvenue au baptême de
        <br />
        Lucie !
        {:else}
        Bienvenue au mariage de
        <br />
        {wedding.name} !
        {/if}
        
      </h1>
      {#if !isLogin}
        <p>
          {#if bapteme}
          Avant de rejoindre le baptême de Lucie vous devez créer votre compte en renseignant
          les informations ci-dessous:
          {:else}
          Avant de rejoindre le mariage de {wedding.name} vous devez créer votre compte en renseignant
          les informations ci-dessous:
          {/if}
        </p>
        <!-- nickname -->
        <Text
          id={"nickname"}
          reset
          required
          bind:value={nickname}
          icon="fa fa-user"
          label="Pseudo/Prénom *"
          placeholder="Pseudo/Prénom *"
          bind:current />

        <!-- email -->
        <Email id={"email"} required bind:value={email} bind:current />

        <!-- password -->
        <Password id={"password"} bind:value={password} bind:current />

        <!-- accept condition -->
        <!-- 
        <Checkbox id={"accept"} bind:value={accept} bind:current required>
          <label for="rgpd_acceptance" class="control-label required">
            J'accepte les
            <a
              href="https://mariage-parfait.com/conditions/"
              target="_blank"
              rel="noopener"
              class="link-secondary cursor-pointer">
              conditions d'utilisation
            </a>
            et de
            <a
              href="https://mariage-parfait.com/confidentialite/"
              target="_blank"
              rel="noopener"
              class="link-secondary cursor-pointer">
              confidentialité
            </a>
            .
          </label>
        </Checkbox> 
        -->

        <span class="note">
          * J'ai dèja un compte,
          <a href="/#" on:click={() => (isLogin = true)}>se connecter</a>
        </span>
      {:else if showDone}
        <div>
          <h3>Félicitations!</h3>
          <p>
            Votre mot de passe a été changé.
            <br />
            Vous pouvez dès maintenant vous connecter en utilisant le nouveau mot de passe.
          </p>
        </div>
      {:else if recoverPassword}
        <div>
          <p>Récupérer votre mot de passe</p>
        </div>
        <Email id={"email"} required bind:value={email} bind:current />
      {:else if validatePassword}
        <p>
          Un code de vérification vous a été envoyé à l'email
          <b>{email}</b>
        </p>
        <p>Saisisez votre nouveau mot de passe</p>
        <Password id={"password"} bind:value={password} bind:current />
        <p>Entrez le code pour continuer.</p>
        <HStack justify="space-evenly" alignment="normal">
          <Digit id={"c1"} focused bind:value={c1} bind:current error={codeError} />
          <Digit id={"c2"} bind:value={c2} bind:current error={codeError} />
          <Digit id={"c3"} bind:value={c3} bind:current error={codeError} />
          <Digit id={"c4"} bind:value={c4} bind:current error={codeError} />
          <Digit id={"c5"} bind:value={c5} bind:current error={codeError} />
          <Digit id={"c6"} bind:value={c6} bind:current error={codeError} />
        </HStack>
      {:else}
        <p>
          Avant de rejoindre le mariage de {wedding.name} vous devez vous connecter à votre compte en
          saisissant vos identifiants:
        </p>

        <!-- email -->
        <Email id={"email"} required bind:value={email} bind:current />

        <!-- password -->
        <Password id={"password"} bind:value={password} bind:current />
        <div class="lost-password">
          <button type="button" on:click={goToLostPassword} class="hyperlink">
            Mot de passe oublié
          </button>
        </div>

        <span class="note">
          * Ce n'est pas mon compte,
          <a href="/#" on:click={() => (isLogin = false)}>s'inscrire</a>
        </span>
      {/if}
    {:else if step == 3}
      <h1>
        {#if bapteme}
        Bienvenue au baptême de
        <br />
        Lucie !
        {:else}
        Bienvenue au mariage de
        <br />
        {wedding.name} !
        {/if}
      </h1>
      <p>
        Un code de vérification vous a été envoyé à l'email
        <b>{$userLogin}</b>
        .
        <br />
        Entrez le code pour continuer.
      </p>
      <Padding>
        <HStack justify="space-evenly" alignment="normal">
          <Digit id={"c1"} focused bind:value={c1} bind:current error={codeError} />
          <Digit id={"c2"} bind:value={c2} bind:current error={codeError} />
          <Digit id={"c3"} bind:value={c3} bind:current error={codeError} />
          <Digit id={"c4"} bind:value={c4} bind:current error={codeError} />
          <Digit id={"c5"} bind:value={c5} bind:current error={codeError} />
          <Digit id={"c6"} bind:value={c6} bind:current error={codeError} />
        </HStack>
      </Padding>

      <div class="note">
        * J'ai perdu mon code,
        <a href="/#" on:click={resendCode}>m'en renvoyer un nouveau</a>
      </div>
    {:else if step == 4}
      <h1>Félicitations !</h1>
      {#if !isLogin}
        <p>
          {#if bapteme}
          Votre compte est confirmé, vous pouvez désormais accéder au blog du baptême et répondre au RSVP.
          {:else}
          Votre compte est confirmé, vous pouvez désormais accéder au blog du mariage et répondre au RSVP.
          {/if}
        </p>
      {:else}
        {#if bapteme}
          <p>Vous pouvez désormais accéder au blog du baptême et répondre au RSVP.</p>
        {:else}
          <p>Vous pouvez désormais accéder au blog du mariage et répondre au RSVP.</p>
        {/if}
      {/if}
      <Checkbox id={"rsvp"} bind:value={rsvp} bind:current>
        <label for="rsvp" class="control-label"> Répondre maintenant au RSVP. </label>
      </Checkbox>
    {/if}
  </article>
</Form>

<style>
  article {
    height: 400px;
    width: 480px;
  }

  @media screen and (max-width: 600px) {
    article {
      width: 100%;
    }
  }

  @media screen and (max-height: 600px) {
    article {
      height: 380px;
    }
  }

  h1 {
    font-family: "Cinzel";
    font-size: 1.5rem;
    text-align: center;
  }

  @media screen and (max-height: 600px) {
    h1 {
      font-size: 1.25rem;
    }
  }

  .note {
    font-size: small;
  }

  div.lost-password button.hyperlink {
    cursor: pointer;
    background: none;
    color: var(--primary-light-color);
    font-size: small;
    border: 0;
    border-radius: 0;
    -webkit-box-shadow: none;
    box-shadow: none;
    margin-top: -10px;
    margin-bottom: 15px;
    padding: 0;
    text-align: left;
  }
</style>
